import { Fragment, useState } from "react";
import styled from "styled-components";

import { describeArcHollow } from "../../utils/helpers";

const Path = styled.path`
  filter: drop-shadow(-3px -3px 5px rgb(0 0 0 / 0.2));

  ${({ hasTransition, isExvert }) => `
    opacity: ${isExvert ? 1 : 0.35};
    ${
      hasTransition
        ? `
      -webkit-transition: all 1s ease;
      -o-transition: all 1s ease;
      transition: all 1s ease;`
        : `transition: none;`
    }
    `}
`;

const Arc = ({
  x,
  y,
  radius,
  startAngle,
  endAngle,
  radiusHollow,
  fill,
  isExvert,
  gap,
  hasTransition,
  handleHover,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleArcHollowHover = () => {
    setIsHovered(true);
    handleHover();
  };

  const handleArcHollowLeave = () => {
    setIsHovered(false);
  };

  return (
    <Fragment>
      <Path
        className="arc"
        d={describeArcHollow(
          x,
          y,
          radius,
          startAngle,
          endAngle,
          radiusHollow + gap / 2,
          gap
        )}
        isExvert={isExvert}
        {...{ fill, hasTransition }}
        onMouseOver={handleArcHollowHover}
        onMouseLeave={handleArcHollowLeave}
      />
    </Fragment>
  );
};

export default Arc;
